import htmlToPdf from "@/utils/htmlToPDF";
export default {
    data() {
        return {
            idCard: '',
            studentName: '',
            //开始学习时间
            startTime: '',
            //结束学习时间
            endTime: '',
            //时长
            period: 0,
            //润沁名字
            trainingInstitution: '广州润沁教育科技有限公司',
            //认证年度
            year: '',
            //专业课数组
            proClass: [],
            //选修课数组
            avoClass: [],
            //最小的数
            minNum: -Infinity,
            //时间
            time: 10,
            name: this.$route.query.name,
            // 性别
            gender: ''
        }
    },
    computed: {
        code() {
            let number = 'zz'
            let id = JSON.parse(this.$route.query.categoryIds)  
            let str = JSON.stringify(id[0])
            let idcard = this.idCard.substring(6,14)
            let length = 7 - str.length
            for(let i = 0; i<length;i++){
                number =  number + '0'
            }
            number = number + id + idcard
            
            return number
        }
    },
    methods: {
        goWhere() {
            this.$router.push({
                path: 'personalcenter'
            })
        },

        getInfo: function () {
            //年度
            this.year = this.$route.query.year;

            // console.log(this.$route.query.end_date);


            //把2018-01-03=>[2018,01,03]分解
            let endDate = this.$route.query.end_date.substr(0, 10).split('-');
            //结束时间
            this.endTime = endDate[0] + '年' + endDate[1] + '月' + endDate[2] + '日';
            //把2018-01-03=>[2018,01,03]分解
            let startDate = this.$route.query.pay_date.substr(0, 10).split('-');
            //开始时间
            this.startTime = startDate[0] + '年' + startDate[1] + '月' + startDate[2] + '日';
            //学生姓名
            this.studentName = this.$store.state.name;

            // 发送请求获取学时
            this.$post('product_category_mapping/get_period', {
                category_ids: this.$route.query.categoryIds,
                offset: 0,
                length: 999
            }).then(res => {
                this.period = res.data.result.data[0].category_period;
                // res.data.result.data.map(item => {
                //     this.period += Number.parseFloat(item.period);
                // })
            }).then(() => {
                //请求个人信息回来
                this.$post('users/profile', { token: this.$store.state.id }).then(res => {
                    this.studentName = res.data.result.name;
                    this.idCard = res.data.result.idcard;
                    this.gender = res.data.result.gender;
                    // return true;
                })
                // .then(() => {
                //     //生成canvas图片
                //     var element = $("#html-content-holder");
                //     var getCanvas;
                //     html2canvas(element, {
                //         onrendered: function (canvas) {
                //             $("#previewImage").append(canvas);
                //             getCanvas = canvas;
                //         }
                //     });

                //     $("#btn-Convert-Html2Image").on("click", function () {
                //         var imgageData = getCanvas.toDataURL("image/png");
                //         var newData = imgageData.replace(
                //             /^data:image\/png/,
                //             "data:application/octet-stream"
                //         );
                //         $("#btn-Convert-Html2Image")
                //             .attr("download", "学时证明.jpg")
                //             .attr("href", newData);
                //     });
                // });
            });
        },
        
        handleWindowPrint(ele, fileName) {
            // 留存原来的 html
            // let bdHtml = window.document.body.innerHTML;
            // let bdHtml = document.querySelector('#app').innerHTML;

            // 要打印的 内容 html
            // document.body.innerHTML =  document.querySelector('#demo').innerHTML;
            // document.body.innerHTML =  document.querySelector('#demo').outerHTML;
            // document.querySelector('#app').innerHTML =  document.querySelector('#demo').outerHTML;
            // document.querySelector('#main').innerHTML =  document.querySelector('#demo').outerHTML;
            
            // 去除页面不必要的 head 标签内  内容， 避免影响打印页 ， title 为保存为 pdf 的文件时的 文件名
            document.head.innerHTML =
                '<meta charset="utf-8">\n' +
                " <title> " +
                fileName +
                "</title>\n" +
                ' <meta name="format-detection" content="telephone=no">\n' +
                ' <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1">\n' +
                ' <meta name="viewport" content="width=device-width,initial-scale=1.0">\n' +
                ' <link rel="stylesheet" href="./static/css/contract.css"/>'; // 生成pdf的外部css样式
            // document.body.innerHTML =  document.querySelector('#demo').outerHTML;
            // document.querySelector('#main').innerHTML =  document.querySelector('#demo').outerHTML;
            // document.body.innerHTML =  document.querySelector('#demo').outerHTML;
            document.body.innerHTML = document.querySelector(ele).outerHTML;

            // window.print();

            // 转异步 等待dom元素渲染（样式）完毕在打印
            setTimeout(() => {
                // 打印
                window.print();
                // 刷新页面
                window.location.reload();
            }, 20);

            // 重新设会当前页面
            // window.document.body.innerHTML = bdHtml;
            // document.querySelector('#app').innerHTML =  bdHtml;
            // 刷新页面
            // window.location.reload();
        },
        goBack() {
            this.$router.go(-1);
        },
        handleDown() {
            htmlToPdf.downloadPDF(
                document.querySelector("#certificate"),
                "学时证明"
            );
        }
    },

    created() {
        this.getInfo();
        document.title = '学时证明';
    },
}